// extracted by mini-css-extract-plugin
module.exports = {"appearDuration":"350ms","popUp":"popUp-23d3abbf","visible":"visible-cf0456be"};